/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface BlocklistModel extends SignalAdminResourceModel {
  [key: string]: any;
}

export interface BlocklistLookupModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class BlocklistApiService extends SignalAdminResourceApiBase<BlocklistModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'blocklists');
  }

  listTeams(): Observable<SignalAdminResourcePage<BlocklistLookupModel>> {
    return this.client.request<SignalAdminResourcePage<BlocklistLookupModel>>({
      method: 'GET',
      url: this.resourceUri('teams'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 1001,
        minimal: true,
        teamTypes: 'STANDARD;AX_PUBLISHER'
      }
    });
  }

  search(query: string, type: 'Advertiser' | 'LineItem' | 'Creative'): Observable<BlocklistLookupModel[]> {
    const normalizedQuery = (query || '').trim();
    const searchQuery = normalizedQuery && normalizedQuery.length < 3 && !normalizedQuery.endsWith('*')
      ? normalizedQuery + '*'
      : normalizedQuery;
    return this.client.request<{searchResults?: BlocklistLookupModel[]}>({
      method: 'GET',
      url: this.resourceUri('search'),
      params: {
        q: searchQuery,
        types: type,
        objectState: 'ACTIVE',
        ...(!searchQuery ? {orderBy: 'NAME'} : {})
      }
    }).pipe(map((response) => response.searchResults || []));
  }
}
